export default {"src":"/_next/static/media/logo-new-footer.1501dbcd.svg","height":150,"width":350,"blurWidth":0,"blurHeight":0};